declare let __webpack_nonce__: string;

const currentScript = document.currentScript;
if (currentScript instanceof HTMLScriptElement && currentScript.nonce) {
    // Webpack consumes this special variable during compilation.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    __webpack_nonce__ = currentScript.nonce;
}
